/** RUC fijo de la empresa de demostración de Senciyo — nunca corresponde a una empresa real. */
export const DEMO_RUC = '20000000000';

/** true solo si el RUC recibido es exactamente el de la empresa demo. */
export function esEmpresaDemo(ruc: string | null | undefined): boolean {
  return ruc === DEMO_RUC;
}
